import { render, staticRenderFns } from "./woodfishMusic.vue?vue&type=template&id=113d5c0e&scoped=true&"
import script from "./woodfishMusic.vue?vue&type=script&lang=js&"
export * from "./woodfishMusic.vue?vue&type=script&lang=js&"
import style0 from "./woodfishMusic.vue?vue&type=style&index=0&id=113d5c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d5c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113d5c0e')) {
      api.createRecord('113d5c0e', component.options)
    } else {
      api.reload('113d5c0e', component.options)
    }
    module.hot.accept("./woodfishMusic.vue?vue&type=template&id=113d5c0e&scoped=true&", function () {
      api.rerender('113d5c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/woodfishMusic.vue"
export default component.exports